import { LayoutTemplate, Code2, Target, Monitor, Languages } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";

const ICONS = {
    "01": LayoutTemplate,
    "02": Code2,
    "03": Target,
    "04": Monitor,
    "05": Languages,
};

export default function Services() {
    const { t } = useLanguage();
    return (
        <section id="services" className="ps-section ps-relative-z" data-testid="services-section">
            <div className="ps-container">
                <div className="ps-section-head">
                    <h2 className="ps-display ps-section-title" data-split data-split-scroll data-testid="services-title"
                        dangerouslySetInnerHTML={{ __html: t.services.title }} />
                    <p className="ps-services-subtitle ps-fade" data-testid="services-subtitle">
                        {t.services.subtitle}
                    </p>
                </div>
                <div className="ps-services" data-testid="services-list">
                    {t.services.items.map((s) => {
                        const Icon = ICONS[s.num];
                        return (
                            <div key={s.num} className="ps-service ps-fade" data-service data-testid={`service-${s.num}`}>
                                <div className="ps-service-icon" aria-hidden="true">
                                    <Icon size={18} strokeWidth={1.75} />
                                </div>
                                <h3 className="ps-service-title">{s.title}</h3>
                                <p className="ps-service-desc">{s.desc}</p>
                                <div className="ps-service-tags">
                                    {s.tags.map((tag) => <span key={tag} className="ps-chip">{tag}</span>)}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
